import { useEffect, useState } from "react";

const DEFAULT_DELAY = 500;

function useDebouncedValue<T = string>(value: T, delay = DEFAULT_DELAY): T {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const id = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(id);
    }, [value, delay]);

    return debounced;
}

export default useDebouncedValue;
